import { isExistPolicy, getPolicyApprover } from 'js/api/privateApi/private-apis'

export default (param, policyType) => new Promise((resolve, reject) => {
  isExistPolicy(param, policyType)
    .then(() => {
      resolve()
    })
    .catch(async (errorData) => {
      try { // 根据dlp规则获取审批者名单
        const approvalInfo = await getPolicyApprover(JSON.parse(errorData.message))
        reject(approvalInfo)
      } catch (error) {
        window.$toast.simpleShow((error.response
          && error.response.data
          && error.response.data.message)
          || error.message, 'warn')
        reject(error)
      }
    })
})
